import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ExamSessionService {
  private _isExamActive$ = new BehaviorSubject<boolean>(false);
  readonly isExamActive$ = this._isExamActive$.asObservable();

  get isExamActive(): boolean {
    return this._isExamActive$.getValue();
  }

  startExam(): void {
    this._isExamActive$.next(true);
  }

  endExam(): void {
    this._isExamActive$.next(false);
  }
}
